export enum ProgressState {
  Active = 1,
  Inactive = 2,
}
